const AR_ROUTES = ['/about', '/services', '/contact', '/europcar', '/chauffeur-service', '/leasing', '/careers', '/partner', '/goldcar', '/truckline', '/used-cars', '/auction', '/book-chauffeur', '/sustainability', '/media', '/leadership', '/faq', '/portal/corporate', '/portal/driver'];

export const toArPath = (p) => (p === '/' ? '/ar' : AR_ROUTES.includes(p) ? `/ar${p}` : '/ar');
export const toEnPath = (p) => p.replace(/^\/ar/, '') || '/';
export const arHref = (href) => (href === '/' ? '/ar' : AR_ROUTES.includes(href) ? `/ar${href}` : href);
export const EUROPCAR_DUBAI_URL = 'https://rentway-emirates.emergent.host';
export const GOLDCAR_UAE_URL = 'https://www.goldcar.com/en-gb/car-rental/locations/dubai/';

// Brand tiles shared by home logo strip, mobile accordion and footer
const brandsEn = [
  { id: 'europcar', label: 'Europcar Car Rental: Dubai & NE', desc: 'Daily, monthly & long-term car rental', href: '/europcar', logo: '/europcar-logo.png', img: '/generated/hero-europcar.jpg' },
  { id: 'goldcar', label: 'Goldcar Car Rental: Dubai & NE', desc: 'Smart-value airport & city car hire', href: '/goldcar', logo: '/goldcar-logo.png', img: '/generated/hero-goldcar.jpg' },
  { id: 'chauffeur', label: 'Eurogulf Premium Chauffeur', desc: 'Executive, VIP & airport chauffeur service', href: '/chauffeur-service', img: '/generated/hero-chauffeur.jpg' },
  { id: 'coaches', label: 'Royal Limousine Coaches', desc: 'Luxury bus & coach transportation', href: '/royal-limousine', img: '/generated/hero-coaches.jpg' },
  { id: 'truckline', label: 'Truckline Transport', desc: 'Vans, trucks & chiller fleet leasing', href: '/truckline', img: '/generated/hero-truckline.jpg' },
  { id: 'used-cars', label: 'Eurogulf Used Cars', desc: 'Certified ex-fleet pre-owned vehicles', href: '/used-cars', img: '/generated/hero-usedcars.jpg' },
];

const en = {
  navLinks: [
    { id: 'home', label: 'Home', href: '/' },
    { id: 'ai-rental', label: 'Discover AI Assisted Car Rental', shortLabel: 'AI Car Rental', href: '/ai-car-rental', badge: 'New' },
    { id: 'car-rental', label: 'Car Rental', href: '/europcar', dropdownId: 'carrental' },
    { id: 'leasing', label: 'Automotive Leasing', href: '/leasing', dropdownId: 'leasing' },
    { id: 'managed', label: 'Managed Transport', href: '/book-chauffeur', dropdownId: 'managed' },
    { id: 'used-cars', label: 'Used Vehicle Sales', href: '/used-cars', dropdownId: 'usedcars', alignRight: true },
    { id: 'value', label: 'Our Value Proposition', href: '/services', dropdownId: 'value', alignRight: true },
    { id: 'about', label: 'About Us', href: '/about', dropdownId: 'about', alignRight: true },
  ],
  menus: {
    carrental: [
      { items: [
        { label: 'Europcar Car Rental: Dubai & NE', href: '/europcar', sub: 'Daily · Weekly · Monthly rental' },
        { label: 'Goldcar Car Rental: Dubai & NE', href: '/goldcar', sub: 'Smart-value airport & city hire' },
        { label: 'Visit Europcar Dubai', href: EUROPCAR_DUBAI_URL, external: true, sub: 'Book online on the Europcar Dubai website' },
        { label: 'Visit Goldcar UAE', href: GOLDCAR_UAE_URL, external: true, sub: 'Book smart-value rentals on goldcar.com' },
      ] },
    ],
    leasing: [
      { items: [{ label: 'Personal Lease', href: '/leasing' }] },
      { header: 'Corporate Mobility Solutions', items: [
        { label: 'Commercial Vehicle Leasing', href: '/truckline' },
        { label: 'Fleet & Contract Management', href: '/dubai-municipality' },
        { label: 'Corporate Rental & Lease', href: '/corporate-rental-lease' },
        { label: 'Partners & Clients', href: '/partners' },
      ] },
    ],
    managed: [
      { items: [
        { label: 'Airport Transfer', href: '/airport-transfer', sub: 'Fixed-fare airport pickups' },
        { label: 'Hourly Chauffeur', href: '/chauffeur-service', sub: 'Executive, by the hour' },
        { label: 'Bus Hire', href: '/royal-limousine', sub: 'Coaches & group transport' },
        { label: 'Managed Booking Engine', href: '/book-chauffeur', sub: 'Instant fares, book online' },
      ] },
    ],
    usedcars: [
      { items: [
        { label: 'Buy Certified Pre-Owned', href: '/used-cars', sub: 'Ex-fleet, inspected' },
        { label: 'B2B Used-Car Auction', href: '/auction', sub: 'Sealed-bid ex-fleet lots' },
      ] },
    ],
    value: [
      { items: [
        { label: 'Collaborate With Us', href: '/collaborate', sub: 'Partnership pathways for every business' },
        { label: 'Mobility Technology', href: '/mobility-technology' },
        { label: 'Complete Mobility Solutions', href: '/services' },
        { label: 'Hospitality Suite', href: '/hospitality' },
        { label: 'Staff & Events Transportation', href: '/staff-transport' },
      ] },
    ],
    about: [
      { items: [
        { label: 'Who We Are', href: '/about', sub: 'Our story since 1976' },
        { label: 'Leadership', href: '/leadership' },
        { label: 'Sustainability', href: '/sustainability' },
        { label: 'Media Center', href: '/media' },
        { label: 'Careers', href: '/careers' },
        { label: 'FAQ', href: '/faq' },
        { label: 'Contact Us', href: '/contact' },
      ] },
      { header: 'Eurogulf 360 Mobility account', items: [
        { label: 'Sign in', href: '/login', sub: 'Personal (B2C) & corporate (B2B) customers' },
        { label: 'Create account', href: '/register', sub: 'Gmail, UAE PASS or email & password' },
        { label: 'Driver Login', href: '/portal/driver', sub: 'Driver / partner portal' },
      ] },
    ],
  },
  footerSolutions: [
    { label: 'AI Assisted Car Rental', href: '/ai-car-rental' },
    { label: 'Car Rental', href: '/europcar' },
    { label: 'Visit Europcar Dubai', href: EUROPCAR_DUBAI_URL, external: true },
    { label: 'Visit Goldcar UAE', href: GOLDCAR_UAE_URL, external: true },
    { label: 'Automotive Leasing', href: '/leasing' },
    { label: 'Managed Transport', href: '/book-chauffeur' },
    { label: 'Used Vehicle Sales', href: '/used-cars' },
    { label: 'Corporate Rental & Lease', href: '/corporate-rental-lease' },
    { label: 'Collaborate With Us', href: '/collaborate' },
  ],
  brandsLinks: brandsEn,
  labels: {
    getQuote: 'Get a Quote',
    contact: 'Contact Us',
    phone: '800 364',
    call: 'Call 800 364',
    whatsapp: 'WhatsApp',
    brandsHeader: 'Our Brands',
    langLabel: 'عربي',
    quoteHref: '/contact',
    menu: 'Menu',
    close: 'Close',
    tagline: 'WE MOVE YOU!',
  },
  footer: {
    about: "The UAE's most diversified mobility group since 1976: car rental, leasing, chauffeur, bus & coach, commercial fleet and pre-owned sales, under one trusted name.",
    tagline: 'WE MOVE YOU!',
    groupHeader: 'Group',
    groupLinks: [
      { label: 'About Us', href: '/about' },
      { label: 'Leadership', href: '/leadership' },
      { label: 'Sustainability', href: '/sustainability' },
      { label: 'Media Center', href: '/media' },
      { label: 'Careers', href: '/careers' },
      { label: 'Collaborate With Us', href: '/collaborate' },
    ],
    brandsHeader: 'Our Brands',
    solutionsHeader: 'Solutions',
    contactHeader: 'Contact',
    phone: '800 364 (Toll-Free)',
    email: 'wemoveyou@eurogulf.ae',
    location: 'EGMG Head Office, 6th Street, Al Quoz 3, Dubai, UAE',
    whatsapp: 'Chat on WhatsApp',
    rights: '© 2026 Eurogulf Mobility Group. All rights reserved.',
    iso: 'ISO 9001:2015 · ISO 10002:2014 Certified',
  },
};

const arLinks = (items) => items.map((l) => ({ ...l, href: arHref(l.href) }));
const arSections = (sections) => sections.map((s) => ({ ...s, items: arLinks(s.items) }));

const brandsAr = arLinks([
  { id: 'europcar', label: 'يوروبكار لتأجير السيارات: دبي والإمارات الشمالية', desc: 'تأجير يومي وشهري وطويل الأمد', href: '/europcar', logo: '/europcar-logo.png', img: '/generated/hero-europcar.jpg' },
  { id: 'goldcar', label: 'جولدكار لتأجير السيارات: دبي والإمارات الشمالية', desc: 'تأجير ذكي بأفضل قيمة من المطارات والمدن', href: '/goldcar', logo: '/goldcar-logo.png', img: '/generated/hero-goldcar.jpg' },
  { id: 'chauffeur', label: 'يوروجلف بريميوم شوفير', desc: 'خدمة سائق خاص تنفيذية وVIP ونقل المطارات', href: '/chauffeur-service', img: '/generated/hero-chauffeur.jpg' },
  { id: 'coaches', label: 'رويال ليموزين للحافلات', desc: 'نقل فاخر بالحافلات والكوتشات', href: '/royal-limousine', img: '/generated/hero-coaches.jpg' },
  { id: 'truckline', label: 'تراكلاين ترانسبورت', desc: 'تأجير الفانات والشاحنات ووحدات التبريد', href: '/truckline', img: '/generated/hero-truckline.jpg' },
  { id: 'used-cars', label: 'يوروجلف للسيارات المستعملة', desc: 'سيارات مستعملة معتمدة من أسطولنا', href: '/used-cars', img: '/generated/hero-usedcars.jpg' },
]);

const ar = {
  navLinks: [
    { id: 'home', label: 'الرئيسية', href: '/ar' },
    { id: 'car-rental', label: 'تأجير السيارات', href: arHref('/europcar'), dropdownId: 'carrental' },
    { id: 'leasing', label: 'التأجير التشغيلي', href: arHref('/leasing'), dropdownId: 'leasing' },
    { id: 'managed', label: 'النقل المُدار', href: arHref('/book-chauffeur'), dropdownId: 'managed' },
    { id: 'used-cars', label: 'بيع السيارات المستعملة', href: arHref('/used-cars'), dropdownId: 'usedcars', alignRight: true },
    { id: 'value', label: 'القيمة المضافة', href: arHref('/services'), dropdownId: 'value', alignRight: true },
    { id: 'about', label: 'عن المجموعة', href: arHref('/about'), dropdownId: 'about', alignRight: true },
  ],
  menus: {
    carrental: arSections([
      { items: [
        { label: 'يوروبكار لتأجير السيارات: دبي والإمارات الشمالية', href: '/europcar', sub: 'يومي · أسبوعي · شهري' },
        { label: 'جولدكار لتأجير السيارات: دبي والإمارات الشمالية', href: '/goldcar', sub: 'تأجير ذكي من المطار والمدينة' },
        { label: 'زوروا موقع يوروبكار دبي', href: EUROPCAR_DUBAI_URL, external: true, sub: 'احجزوا عبر موقع يوروبكار دبي' },
        { label: 'زوروا موقع جولدكار الإمارات', href: GOLDCAR_UAE_URL, external: true, sub: 'احجزوا تأجيراً ذكياً بأفضل قيمة عبر goldcar.com' },
      ] },
    ]),
    leasing: [
      ...arSections([{ items: [{ label: 'التأجير الشخصي', href: '/leasing' }] }]),
      { header: 'حلول التنقل المؤسسي', items: arLinks([
        { label: 'تأجير المركبات التجارية', href: '/truckline' },
        { label: 'إدارة الأساطيل والعقود', href: '/dubai-municipality' },
        { label: 'التأجير المؤسسي', href: '/corporate-rental-lease' },
        { label: 'الشركاء والعملاء', href: '/partners' },
      ]) },
    ],
    managed: arSections([
      { items: [
        { label: 'نقل المطار', href: '/airport-transfer', sub: 'نقل مطار بأسعار ثابتة' },
        { label: 'سائق بالساعة', href: '/chauffeur-service', sub: 'تنفيذي بالساعة' },
        { label: 'تأجير الحافلات', href: '/royal-limousine', sub: 'حافلات ونقل المجموعات' },
        { label: 'محرك الحجز المُدار', href: '/book-chauffeur', sub: 'أسعار فورية واحجز مباشرة' },
      ] },
    ]),
    usedcars: arSections([
      { items: [
        { label: 'شراء سيارة مستعملة معتمدة', href: '/used-cars', sub: 'من الأسطول، مفحوصة' },
        { label: 'مزاد السيارات المستعملة (B2B)', href: '/auction', sub: 'مزايدة مغلقة على مركبات الأسطول' },
      ] },
    ]),
    value: arSections([
      { items: [
        { label: 'التعاون معنا', href: '/collaborate', sub: 'مسارات شراكة لكل الأعمال' },
        { label: 'شراكة معنا', href: '/partner' },
        { label: 'تقنية التنقل', href: '/mobility-technology' },
        { label: 'حلول التنقل المتكاملة', href: '/services' },
        { label: 'حلول الضيافة', href: '/hospitality' },
        { label: 'نقل الموظفين والفعاليات', href: '/staff-transport' },
      ] },
    ]),
    about: arSections([
      { items: [
        { label: 'من نحن', href: '/about', sub: 'قصتنا منذ ١٩٧٦' },
        { label: 'القيادة', href: '/leadership' },
        { label: 'الاستدامة', href: '/sustainability' },
        { label: 'المركز الإعلامي', href: '/media' },
        { label: 'الوظائف', href: '/careers' },
        { label: 'الأسئلة الشائعة', href: '/faq' },
        { label: 'اتصل بنا', href: '/contact' },
      ] },
      { header: 'حساب يوروجلف 360 للتنقل', items: [
        { label: 'تسجيل الدخول', href: '/login', sub: 'عملاء الأفراد والشركات' },
        { label: 'إنشاء حساب', href: '/register', sub: 'Gmail أو الهوية الرقمية أو البريد الإلكتروني' },
        { label: 'دخول السائقين', href: '/portal/driver', sub: 'بوابة السائقين والشركاء' },
      ] },
    ]),
  },
  footerSolutions: arLinks([
    { label: 'تأجير السيارات', href: '/europcar' },
    { label: 'زوروا موقع يوروبكار دبي', href: EUROPCAR_DUBAI_URL, external: true },
    { label: 'زوروا موقع جولدكار الإمارات', href: GOLDCAR_UAE_URL, external: true },
    { label: 'التأجير التشغيلي', href: '/leasing' },
    { label: 'النقل المُدار', href: '/book-chauffeur' },
    { label: 'بيع السيارات المستعملة', href: '/used-cars' },
    { label: 'التأجير المؤسسي', href: '/corporate-rental-lease' },
    { label: 'شراكة معنا', href: '/partner' },
  ]),
  brandsLinks: brandsAr,
  labels: {
    getQuote: 'احصل على عرض سعر',
    contact: 'اتصل بنا',
    phone: '800 364',
    call: 'اتصل 800 364',
    whatsapp: 'واتساب',
    brandsHeader: 'علاماتنا التجارية',
    langLabel: 'EN',
    quoteHref: '/ar/contact',
    menu: 'القائمة',
    close: 'إغلاق',
    tagline: 'نحن ننقلك!',
  },
  footer: {
    about: 'مجموعة التنقل الأكثر تنوعاً في الإمارات منذ عام ١٩٧٦: تأجير السيارات، التأجير التشغيلي، السائق الخاص، الحافلات، الأساطيل التجارية، والسيارات المستعملة تحت اسم واحد موثوق.',
    tagline: 'نحن ننقلك!',
    groupHeader: 'المجموعة',
    groupLinks: arLinks([
      { label: 'من نحن', href: '/about' },
      { label: 'القيادة', href: '/leadership' },
      { label: 'الاستدامة', href: '/sustainability' },
      { label: 'المركز الإعلامي', href: '/media' },
      { label: 'الوظائف', href: '/careers' },
      { label: 'شراكة معنا', href: '/partner' },
    ]),
    brandsHeader: 'علاماتنا التجارية',
    solutionsHeader: 'الحلول',
    contactHeader: 'تواصل معنا',
    phone: '800 364 (خط مجاني)',
    email: 'wemoveyou@eurogulf.ae',
    location: 'المكتب الرئيسي لمجموعة يوروجلف، الشارع السادس، القوز الصناعية ٣، دبي، الإمارات',
    whatsapp: 'تحدث معنا عبر واتساب',
    rights: '© ٢٠٢٦ مجموعة يوروجلف للتنقل. جميع الحقوق محفوظة.',
    iso: 'معتمدة وفق ISO 9001:2015 و ISO 10002:2014',
  },
};

export const getNavData = (isAr) => (isAr ? ar : en);
